import { IStepSixModel } from './IStepSixModel';

const StepSixModelInitialState: IStepSixModel = {
  codeMelliBimehGozar: null,
  codeMelliSabtAhval: null,
  hasEstelamSabtAhval: null,
  jensiatiBimehGozar: null,
  loggedInUserIsBimehGozar: false,
  naamBimehGozar: null,
  namKhanevadegiBimehGozar: null,
  tarikhTavalodBimehGozar: null,
  tarikhTavaloodSabtAhval: null,
  isMalek: true,
  isMostajer: false,
};

export default StepSixModelInitialState;
